import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openReader } from '../features/Reader';

const ArticleCard = ({
  author,
  section,
  articleTitle,
  articleUrl,
  imgUrl,
  id,
}) => {
  const dispatch = useDispatch();

  return (
    <div
      className="cursor-pointer border border-[#34345c] bg-[#d6daf0] rounded-md min-w-[95%] overflow-hidden"
      onClick={() => {
        dispatch(openReader(articleUrl));
      }}
    >
      <div className="border-b border-[#34345c]">
        <img src={imgUrl} alt={articleTitle} className="w-[100%] h-[auto]" />
      </div>
      <div className="p-3">
        <h2 className="font-bold text-2xl text-[#34345c]">{articleTitle}</h2>
      </div>
    </div>
  );
};

export default ArticleCard;
